"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPlacementPeuLiquiditeCorporationTrads = void 0;
exports.ESubPlacementPeuLiquiditeCorporationTrads = {
    actions: "Actions du CAC 40",
    livret_bancaire: "Livret bancaire",
    scpi: "SCPI",
};
